import {Pipe, PipeTransform} from '@angular/core';
import {Product} from "./product";

@Pipe({
    name: 'filterProductsByState',
    standalone: false
})
export class FilterProductsByStatePipe implements PipeTransform {

  transform(products: Product[], state: string): Product[] {
    let filteredProducts: Product[];

    switch (state) {
      case '':
        filteredProducts = products;
        break;
      case 'all':
        filteredProducts = products;
        break;
      case 'active':
        filteredProducts = products.filter((product: Product): boolean => product.active);
        break;
      case 'inactive':
        filteredProducts = products.filter((product: Product): boolean => !product.active);
        break;
      case 'updateAvailable':
        filteredProducts = products.filter((product: Product): boolean => product.updateAvailable);
        break;
    }

    return filteredProducts;
  }

}
